import { useState } from "react";
import { SubscribeInterstitial } from "@/components/SubscribeInterstitial";
import { useT } from "@/lib/i18n";

/**
 * Membership interstitial for club actions a member can't take without a
 * subscription. Which controls are gated comes from the server's `access.can`;
 * gated controls render a GateNotice that opens this.
 */
export function useClubGate() {
  const { t } = useT();
  const [subscribeOpen, setSubscribeOpen] = useState(false);

  const interstitial = (
    <SubscribeInterstitial
      isOpen={subscribeOpen}
      onClose={() => setSubscribeOpen(false)}
      title={t("clubs.interstitialTitle")}
      description={t("clubs.interstitialDescription")}
    />
  );

  return { interstitial, openSubscribe: () => setSubscribeOpen(true) };
}
